import { T } from '../../helpers/i18n';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import featureFlags from '../../helpers/featureFlags';
import { FEATURE_FLAGS } from '../../constants/featureFlags';
import { UserPickerField } from './UserPickerField';

const MAX_OPTIONAL_REVIEWERS = 50;

export const CoReviewers = () => {
  const isOptionalReviewers = !!featureFlags.get(FEATURE_FLAGS.OPTIONAL_REVIEWERS);

  return (
    <UserPickerField
      fieldName={ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS}
      label={
        T.translate(isOptionalReviewers ? 'new.optionalReviewers' : 'new.coReviewers') as string
      }
      maxAssignees={isOptionalReviewers ? MAX_OPTIONAL_REVIEWERS : undefined}
    />
  );
};
